import { buildCssClassName } from "@/3514/utils"

import "./styles.scss"

type Props = {
    className?: string
    fullWith?: boolean
}

const DividerLine = ({ className = "", fullWith = false }: Props) => {
    return <div className={buildCssClassName("divider-line mx-auto", className, { "full-width": fullWith })} />
}

export default DividerLine
